import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.div`
  margin: ${({ theme }) => theme.CONSTANTS.XH * 1}px auto 0 auto;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  line-height: 1.6;
  font-weight: 700;
  font-family: "Inter", sans-serif;
  align-items: flex-start;
  text-align: start;
  width: 85%;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
    width: 100%;
    margin: 0 ${({ theme }) => theme.CONSTANTS.XW * 4}px;
  }
`;

export const ColorRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 ${({ theme }) => theme.CONSTANTS.XW * 7}px;
  position: relative;

  @media (min-width: 1025px) {
    padding: 0 ${({ theme }) => theme.CONSTANTS.XW * 4}px;
  }
`;

export const ColorCircle = styled.button<{ $active?: boolean }>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border-style: solid;
  border-width: ${({ $active }) => ($active ? "3px" : "2px")};
  border-color: ${({ $active, theme }) =>
    $active ? theme.THEME.neonBlue : theme.THEME.white};
  cursor: pointer;
  transition: border-color 0.2s, border-width 0.2s;

  @media (min-width: 1025px) {
    width: 52px;
    height: 52px;

    border-width: ${({ $active }) => ($active ? "4px" : "2px")};
  }
`;

export const ColorPickerButton = styled.label<{ $current?: string }>`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 2px solid ${({ $current }) => $current || "#FFFFFF"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  @media (min-width: 1025px) {
    width: 55px;
    height: 55px;
  }

  img {
    width: 28px;
    pointer-events: none;
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.4));
    align-items: center;
    justify-content: center;

    @media (min-width: 1025px) {
      width: 35px;
    }
  }

  &::after {
    content: "";
    position: absolute;
    right: -4px;
    bottom: -4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${({ $current }) => $current || "#FFFFFF"};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);

    @media (min-width: 1025px) {
      width: 20px;
      height: 20px;
    }
  }

  &:hover {
    transform: scale(1.06);
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.45);
  }
  &:active {
    transform: scale(0.98);
  }

  input[type="color"] {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
    border: none;
    padding: 0;
    margin: 0;
  }
`;

export const PickerPopover = styled.div`
  position: absolute;
  top: 42px;
  z-index: 50;
  background: ${({ theme }) => theme.THEME.black};
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.45);

  .react-colorful {
    width: 220px;
    height: 180px;
  }
  .react-colorful__saturation-pointer,
  .react-colorful__hue-pointer {
    box-shadow: 0 0 0 2px #fff, 0 0 2px rgba(0, 0, 0, 0.7);
  }
`;
